import { ASSET_ROOT, DEBUG, assetUrl } from "../assets";
import { FONT_UI, LOOKS, type LookKey } from "../config/assetManifest";
import { k } from "./kaplay";

export const missingAssets: string[] = [];

async function exists(path: string): Promise<boolean> {
    try {
        const res = await fetch(assetUrl(path), { method: "HEAD" });
        return res.ok && !res.headers.get("content-type")?.includes("text/html");
    } catch {
        return false;
    }
}

async function loadLook(key: LookKey) {
    const def = LOOKS[key];
    if (!(await exists(def.path))) {
        missingAssets.push(def.path);
        return;
    }
    const rows = def.rows ?? 1;
    const cols = (def.poses?.length ?? 1) / rows;
    k.loadSprite(key, def.path, { sliceX: cols, sliceY: rows });
}

async function loadFont() {
    if (await exists(FONT_UI.path)) k.loadFont(FONT_UI.key, FONT_UI.path);
    else missingAssets.push(FONT_UI.path);
}

export async function loadAssets(onProgress: (done: number) => void) {
    k.loadRoot(ASSET_ROOT);
    const jobs = [...(Object.keys(LOOKS) as LookKey[]).map(loadLook), loadFont()];
    let finished = 0;
    await Promise.all(jobs.map((job) => job.then(() => onProgress(++finished / jobs.length))));
    if (DEBUG && missingAssets.length) console.table(missingAssets);
}
